import vMenu from './Menu.vue';

export { vMenu };



// WEBPACK FOOTER //
// ./src/baseComponents/components/Menu/index.js